import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-no-found-svg-icon',
  imports: [NgClass],
  templateUrl: './no-found-svg-icon.component.html',
  styleUrl: './no-found-svg-icon.component.css',
})
export class NoFoundSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
